<template>
  <div class="customer-common">
    <div>
      <b-form-group v-if="showCustomerType">
        <label class="font-weight-bold mr-3">Loại KH:</label>
        <b-form-radio-group
          v-model="customerModel.customerKind"
          :options="bizCustomerTypeOptions"
          :disabled="isDisabled || disableCustomerType"
          size="sm"
        />
      </b-form-group>
      <b-form-group v-if="showCustomerType && isBizCustomer">
        <label>Mã số thuế:<b class="text-danger">*</b></label>
        <Autosuggest
          :model="customerModel.customerMst"
          :suggestions="filteredBusinessOptions"
          :suggestionName="'taxNo'"
          placeholder="Tìm DN theo MST / tên / SĐT"
          :limit="10"
          @select="onSelectBusiness"
          @change="onSearchBusinessChange"
          :disabled="isDisabled"
        >
          <template #custom="{ suggestion }">
            <div class="d-flex flex-column">
              <span class="text-primary mb-1" v-if="suggestion.item.taxNo"
                >({{ suggestion.item.taxNo }})</span
              >
              <span v-if="suggestion.item.name">{{
                suggestion.item.name
              }}</span>
              <span v-else class="text-muted">{{
                suggestion.item.message
              }}</span>
            </div>
          </template>
        </Autosuggest>
      </b-form-group>
      <b-form-group v-if="showCustomerType && isBizCustomer">
        <label>Người đại diện:</label>
        <b-form-input
          class="input-style"
          size="sm"
          type="text"
          v-model="customerModel.customerRepresentative"
          :disabled="isDisabled"
          placeholder="Họ tên người đại diện"
        ></b-form-input>
      </b-form-group>
      <!-- KH doanh nghiệp: chỉ search theo MST (ô trên). SĐT KHÔNG hiện —
           tự lấy từ DN khi onSelectBusiness (customerMobile = business.phoneNo).
           Tránh bắt user nhập/search SĐT khách lẻ cho DN. -->
      <b-form-group v-if="!(showCustomerType && isBizCustomer)">
        <label>Điện thoại:<b class="text-danger">*</b> </label>
        <i
          v-show="customerModel.customerId"
          @click="showPopoverCustomer = !showPopoverCustomer"
          class="far fa-caret-square-down text-warning ml-2"
          id="popover-button-sync"
          style="cursor: pointer"
        ></i>
        <Autosuggest
          :model="customerModel.customerMobile"
          :suggestions="filteredOptionsCustomer"
          :suggestionName="'phoneNumber'"
          placeholder="số điện thoại"
          :limit="10"
          @select="onSelectCustomer"
          @change="onSearchChange"
          :disabled="isDisabled"
        >
          <template #custom="{ suggestion }">
            <div>
              <div class="d-flex flex-column">
                <span
                  class="text-primary mb-1"
                  v-if="suggestion.item.phoneNumber"
                  >({{ suggestion.item.phoneNumber }})</span
                >
                <span v-if="suggestion.item.fullName">{{
                  suggestion.item.fullName
                }}</span>
                <span v-else>{{ suggestion.item.message }}</span>
              </div>
            </div>
          </template>
        </Autosuggest>
        <b-form-invalid-feedback
          :state="validateCustomer"
          id="input-phone-live-feedback"
          >Vui lòng nhập số điện thoại hợp lệ!</b-form-invalid-feedback
        >
      </b-form-group>
      <b-form-group>
        <label>
          {{
            showCustomerType && isBizCustomer
              ? 'Tên doanh nghiệp'
              : 'Họ và tên'
          }}:<b class="text-danger">*</b>
          <!-- <span class="text-primary" v-html="pointText"></span> -->
        </label>
        <b-form-input
          class="input-style"
          size="sm"
          type="text"
          v-model="customerModel.customerName"
          :disabled="isDisabled"
          placeholder="Tên khách hàng"
        ></b-form-input>
      </b-form-group>
      <b-form-group v-if="!(showCustomerType && isBizCustomer)">
        <div class="type-appellation">
          <div class="appellation">
            <label for="input-name"
              >Danh xưng:<b class="text-danger">*</b>
            </label>
            <treeselect
              :options="appellationOptions"
              v-model="customerModel.customerAppellation"
              :multiple="false"
              placeholder="Chọn danh xưng"
              noResultsText="Không có kết quả"
              :clearable="false"
              size="sm"
              :disabled="isDisabled"
            ></treeselect>
          </div>
          <!-- <div class="type">
            <label for="input-name"> Loại khách: </label>
            <treeselect
              :options="optionsCustomerType"
              :multiple="false"
              placeholder="Chọn loại khách"
              noResultsText="Không có kết quả"
              :match-keys="['label', 'custom']"
              v-model="customerModel.customerType"
              :clearable="false"
              openDirection="bottom"
            >
            </treeselect>
          </div> -->
        </div>
      </b-form-group>
      <!-- Pháp lý KH — đồng bộ field với HĐMB / Đề Nghị tạo HĐ -->
      <b-form-group>
        <label>Email:</label>
        <b-form-input
          class="input-style"
          size="sm"
          type="text"
          v-model="customerModel.customerEmail"
          :disabled="isDisabled"
          placeholder="email@example.com"
        ></b-form-input>
      </b-form-group>
      <b-form-group v-if="!(showCustomerType && isBizCustomer)">
        <label>Ngày sinh:</label>
        <b-form-input
          class="input-style"
          size="sm"
          type="date"
          v-model="customerModel.customerDob"
          :disabled="isDisabled"
        ></b-form-input>
      </b-form-group>
      <b-form-group v-if="!(showCustomerType && isBizCustomer)">
        <label>Số CCCD/CMND:</label>
        <b-form-input
          class="input-style"
          size="sm"
          type="text"
          v-model="customerModel.customerCccdNo"
          :disabled="isDisabled"
          placeholder="VD: 030123456789"
        ></b-form-input>
      </b-form-group>
      <b-form-group v-if="!(showCustomerType && isBizCustomer)">
        <label>Ngày cấp CCCD:</label>
        <b-form-input
          class="input-style"
          size="sm"
          type="date"
          v-model="customerModel.customerCccdDate"
          :disabled="isDisabled"
        ></b-form-input>
      </b-form-group>
      <b-form-group v-if="!(showCustomerType && isBizCustomer)">
        <label>Nơi cấp CCCD:</label>
        <b-form-input
          class="input-style"
          size="sm"
          type="text"
          v-model="customerModel.customerCccdPlace"
          :disabled="isDisabled"
          placeholder="VD: Cục CSQLHC về TTXH"
        ></b-form-input>
      </b-form-group>
      <!-- <b-form-group>
        <label>Thành phố:</label>
        <treeselect
          :options="listCity"
          :multiple="false"
          placeholder="Chọn thành phố"
          noResultsText="Không có kết quả"
          :match-keys="['label', 'custom']"
          v-model="customerModel.customerCity"
          openDirection="bottom"
        >
        </treeselect>
      </b-form-group>
      <b-form-group>
        <label>Quận huyện:</label>
        <treeselect
          :options="listDistrict"
          :multiple="false"
          placeholder="Chọn tỉnh thành"
          noResultsText="Không có kết quả"
          :match-keys="['label', 'custom']"
          v-model="customerModel.customerDistrict"
          openDirection="bottom"
          :disabled="listDistrict.length ? false : true"
        >
        </treeselect>
      </b-form-group>
      <b-form-group>
        <label>Phường xã:</label>
        <treeselect
          :options="listWard"
          :multiple="false"
          placeholder="Chọn phường xã"
          noResultsText="Không có kết quả"
          :match-keys="['label', 'custom']"
          v-model="customerModel.customerWard"
          openDirection="bottom"
          :disabled="listWard.length ? false : true"
        >
        </treeselect>
      </b-form-group> -->
      <b-form-group>
        <label
          >{{
            showCustomerType && isBizCustomer ? 'Địa chỉ trụ sở' : 'Địa chỉ'
          }}:</label
        >
        <b-form-textarea
          v-model="customerModel.customerAddress"
          size="sm"
          class="input-style"
          :placeholder="'Địa chỉ khách hàng'"
          :rows="6"
          :max-rows="6"
          :disabled="isDisabled"
        ></b-form-textarea>
      </b-form-group>
    </div>
    <div>
      <div>
        <b-popover
          :show.sync="showPopoverCustomer"
          target="popover-button-sync"
          title="Lịch sử khách hàng"
          triggers="hover focus"
          id="popover-customer"
        >
          <div>
            <a
              @click="copyCustomerMobile"
              class="mt-1 d-block"
              v-if="
                customerModel.customerMobile &&
                customerModel.customerMobile.length > 8
              "
              ><b class="text-dark">Số điện thoại :</b>
              {{ customerModel.customerMobile }}
              <i
                class="far fa-copy text-primary cursor-pointer ml-1"
                style="font-size: 0.85rem"
              ></i>
            </a>
            <a href="#" class="mt-1 d-block"
              ><b class="text-dark">Đơn hàng :</b>
              {{ customerTransaction.orderCount }}</a
            >
            <a href="#" class="mt-1 d-block"
              ><b class="text-dark">Bán lẻ :</b>
              {{ customerTransaction.retailCount }}</a
            >
            <a href="#" class="mt-1 d-block"
              ><b class="text-dark">Bán buôn:</b>
              {{ customerTransaction.wholesaleCount }}</a
            >
            <a href="#" class="mt-1 d-block"
              ><b class="text-dark">Trả hàng:</b>
              {{ customerTransaction.refundCount }}</a
            >
          </div>
          <div class="mt-3 text-center">
            <span class="text-link" @click="viewCustomerTransaction"
              >Chi tiết</span
            >
          </div>
        </b-popover>
      </div>
    </div>
  </div>
</template>

<script>
import ApiService from '@/core/services/api.service';
import { CUSTOMER_TYPE } from '@/utils/constants';
import {
  CUSTOMER_TYPE as BIZ_CUSTOMER_TYPE,
  CUSTOMER_TYPE_OPTIONS as BIZ_CUSTOMER_TYPE_OPTIONS,
} from '@/core/constants/contractRequest';
import { cloneDeep } from 'lodash';
import Treeselect from '@riophae/vue-treeselect';
import '@riophae/vue-treeselect/dist/vue-treeselect.css';
import { ASYNC_SEARCH } from '@riophae/vue-treeselect';
import { removeAccents, copyClipBoard } from '@/utils/common';
import { mapGetters } from 'vuex';
import { SET_CUSTOMER_ORDER_INFO } from '@/core/services/store/modules/order/order-customer-info.module.js';
import Autosuggest from '@/view/base/auto-sugguest/AutoSuggest.vue';
import { TIME_TRIGGER } from '@/utils/constants';
import decounce from 'debounce';

export default {
  props: [
    'onSubmiting',
    'billData',
    'fromOrder',
    'action',
    'contractData',
    'isDisabled',
    'showCustomerType',
    'disableCustomerType',
  ],
  data() {
    return {
      listCity: [],
      listDistrict: [],
      listWard: [],
      selectedCustomerSource: null,
      listCustomerSource: [],
      customerModel: {
        customerId: null,
        customerMobile: '',
        customerName: '',
        customerLastName: '',
        customerAddress: '',
        customerCity: null,
        customerDistrict: null,
        customerWard: null,
        customerType: 1,
        customerAppellation: null,
        totalPoint: 0,
        // Pháp lý KH (đồng bộ field với HĐMB) — date dạng YYYY-MM-DD cho input[type=date].
        customerEmail: '',
        customerDob: '',
        customerCccdNo: '',
        customerCccdDate: '',
        customerCccdPlace: '',
        customerKind: 'CUSTOMER',
        customerMst: '',
        customerRepresentative: '',
        // ADDITIVE — FK customer_businesses khi chọn DN có sẵn (parity HĐMB).
        customerBusinessId: null,
      },
      optionsCustomerType: [],
      appellationOptions: [
        { id: null, label: 'Chọn danh xưng' },
        { id: 1, label: 'Anh' },
        { id: 2, label: 'Chị' },
        { id: 3, label: 'Khác' },
      ],
      showPopoverCustomer: false,
      defaultOptionCustomers: null,
      skipLoaded: false,
      isOpenCustomerSearch: false,
      customerTransaction: {
        orderCount: 0,
        retailCount: 0,
        wholesaleCount: 0,
        refundCount: 0,
      },
      filteredOptionsCustomer: [],
      optionsCustomer: [],
      // KH doanh nghiệp — search DN qua GET /businesses (parity HĐMB).
      filteredBusinessOptions: [],
    };
  },
  components: {
    Treeselect,
    Autosuggest,
  },
  created() {
    this.mappingEnum();
    // this.fetchCity();
    // if (this.action === 'update') {
    //   const customerModel = this.getOrderCustomerInfo;
    //   this.defaultOptionCustomers = [
    //     {
    //       id: customerModel.customerId,
    //       label: customerModel.customerMobile,
    //       customLabel: customerModel.customerName,
    //     },
    //   ];
    //   this.customerModel = customerModel;
    //   this.getCustomerInfoUpdatedById(this.customerModel.customerId);
    // }
    this.$nextTick(() => {
      this.skipLoaded = true;
    });
  },
  mounted() {
    if (this.billData) {
      // Merge với customerModel mặc định để đảm bảo các field pháp lý mới
      // luôn tồn tại + reactive (parent cũ có thể chưa khai báo).
      this.customerModel = {
        ...this.customerModel,
        ...cloneDeep(this.billData.customerModel),
      };
      this.getCustomerInfoUpdatedById(this.customerModel.customerId);
    }
    if (this.contractData) {
      this.getCustomerInfoById(this.contractData.customerId);
      // this.customerModel = {
      //   customerAddress: this.contractData.customerAddress,
      //   customerAppellation: 1,
      //   customerCity: undefined,
      //   customerDistrict: null,
      //   customerId: this.contractData.customerId,
      //   customerLastName: undefined,
      //   customerMobile: this.contractData.customerPhone,
      //   customerName: this.contractData.customerName,
      //   customerType: undefined,
      //   customerWard: null,
      // };
    }
  },
  computed: {
    ...mapGetters(['getOrderCustomerInfo']),
    validateCustomer() {
      if (!this.onSubmiting) {
        return true;
      }

      if (
        !this.customerModel.customerMobile ||
        this.customerModel.customerMobile.trim().length < 8 ||
        this.customerModel.customerMobile.trim().length > 15
      ) {
        return false;
      }

      return true;
    },
    pointText: {
      get() {
        return `<b>(Tổng điểm: ${this.customerModel.totalPoint || 0})</b>`;
      },
      set(newValue) {
        return newValue ? newValue : '';
      },
    },
    bizCustomerTypeOptions() {
      return BIZ_CUSTOMER_TYPE_OPTIONS;
    },
    isBizCustomer() {
      return this.customerModel.customerKind === BIZ_CUSTOMER_TYPE.BUSSINESS;
    },
  },
  watch: {
    'customerModel.customerMobile': function (newValue) {
      if (this.skipLoaded) {
        if (!newValue) {
          this.customerModel.customerName = null;
          this.pointText = null;
        }
      }
    },
    'customerModel.customerCity': function (city) {
      if (this.skipLoaded) {
        this.listDistrict = [];
        this.listWard = [];
        this.customerModel.customerDistrict = null;
        this.customerModel.customerWard = null;
        if (city) {
          this.getDistrict();
        }
      }
    },
    'customerModel.customerDistrict': function (district) {
      if (this.skipLoaded) {
        this.listWard = [];
        this.customerModel.customerWard = null;
        if (district) {
          // this.getWard();
        }
      }
    },
    customerModel: {
      handler: function (value, oldValue) {
        if (this.skipLoaded) {
          this.$store.dispatch(SET_CUSTOMER_ORDER_INFO, value);
          this.loadContactCustomer();
          this.$emit('onUpdate', value);
        }
        if (!oldValue) {
          // this.getTransactionByCustomerId(value.customerId);
        } else if (oldValue && value !== oldValue) {
          // this.getTransactionByCustomerId(value.customerId);
        }
      },
      deep: true,
    },
  },
  methods: {
    debounceInput: decounce(function () {
      this.getListCustomer();
    }, TIME_TRIGGER),
    debounceBusinessInput: decounce(function () {
      this.getListBusiness();
    }, TIME_TRIGGER),
    onSearchBusinessChange(text) {
      // Gõ trong ô MST → ghi thẳng vào customerMst, reset KH đã chọn, debounce search DN.
      const value = text || '';
      this.customerModel.customerMst = value;
      this.customerModel.customerId = null;
      this.customerModel.customerBusinessId = null;
      this.filteredBusinessOptions = [];
      if (!value.trim()) return;
      this.debounceBusinessInput();
    },
    getListBusiness() {
      const text = (this.customerModel.customerMst || '').trim();
      if (!text) return;
      ApiService.query('businesses', {
        params: { search: text, page: 1, limit: 10 },
      })
        .then((res) => {
          const payload = (res && res.data && res.data.data) || null;
          let list = [];
          if (Array.isArray(payload)) list = payload;
          else if (payload && Array.isArray(payload.data)) list = payload.data;
          if (list.length) {
            this.filteredBusinessOptions = list;
          } else {
            this.filteredBusinessOptions = [
              { message: 'DN không có trong hệ thống', taxNo: text },
            ];
          }
        })
        .catch(() => {
          this.filteredBusinessOptions = [];
        });
    },
    onSelectBusiness(option) {
      const item = option && option.item ? option.item : null;
      if (!item) return;
      if (item.id) {
        // Chọn DN có sẵn → auto-fill như HĐMB. SĐT lấy từ DN (phoneNo) để
        // BE vẫn find/create Customer lẻ theo SĐT (ADDITIVE); đồng thời lưu
        // customerBusinessId = link DN thật (parity HĐMB).
        this.customerModel.customerBusinessId = item.id;
        this.customerModel.customerMst = item.taxNo || '';
        this.customerModel.customerName = item.name || '';
        this.customerModel.customerMobile = item.phoneNo || '';
        this.customerModel.customerAddress = item.address || '';
        this.customerModel.customerEmail = item.email || '';
        this.customerModel.customerRepresentative = item.representative || '';
        // Reset để BE resolve Customer theo SĐT DN vừa chọn, không dính KH lẻ cũ.
        this.customerModel.customerId = null;
      } else {
        // DN không có trong hệ thống → không link, vẫn lưu snapshot MST.
        this.customerModel.customerBusinessId = null;
        this.customerModel.customerMst = item.taxNo || '';
      }
    },
    mappingEnum() {
      this.optionsCustomerType = cloneDeep(CUSTOMER_TYPE).reduce(
        (result, element) => {
          if (element.value !== null) {
            result.push({
              id: element.id,
              label: element.name,
              custom: removeAccents(element.name),
            });
          }
          return result;
        },
        [],
      );
    },
    copyCustomerMobile() {
      const customerMobile = this.customerModel.customerMobile || '';
      if (customerMobile.length > 8) {
        copyClipBoard(customerMobile, 'Số điện thoại');
      }
    },
    onSelectCustomer(option) {
      if (option.item && option.item.id) {
        this.customerModel.customerId = option.item.id;
        this.customerModel.customerMobile = option.item.phoneNumber;
        this.customerModel.customerAppellation = option.item.gender;
        this.getCustomerInfoById(option.item.id);
        // this.getTransactionByCustomerId(option.item.id);
      } else {
        this.customerModel.customerId = '';
        this.customerModel.customerMobile = option.item.phoneNumber;
        this.customerModel.customerName = '';
        this.customerModel.totalPoint = 0;
      }
    },
    loadContactCustomer() {
      if (this.contractData && Object.keys(this.contractData).length) {
        this.contractData.customerId = this.customerModel.customerId || null;
        this.contractData.customerPhone = this.customerModel.customerMobile;
        this.contractData.customerName = this.customerModel.customerName;
        this.contractData.customerAddress = this.customerModel.customerAddress;
        this.contractData.customerGender =
          this.customerModel.customerAppellation;
        //todo nếu có làm KH doanh nghiệp
        this.contractData.customerType = 'CUSTOMER';
      }
    },
    onSearchChange(searchQuery) {
      if (!searchQuery) {
        searchQuery = '';
      }
      this.customerModel.customerMobile = searchQuery;
      this.optionsCustomer = [];
      this.filteredOptionsCustomer = [...this.optionsCustomer];
      this.debounceInput();
    },
    getListCustomer() {
      const text = this.customerModel.customerMobile
        ? this.customerModel.customerMobile.trim()
        : null;
      if (!text) {
        return;
      }
      ApiService.get(`customers/get-by-phone?phoneNumber=${text}`).then(
        (data) => {
          this.optionsCustomer = data.data.data;
          if (this.optionsCustomer.length > 0) {
            this.filteredOptionsCustomer = [...this.optionsCustomer];
          } else {
            this.filteredOptionsCustomer = [
              { message: 'SĐT không có trong hệ thống', phoneNumber: text },
            ];
          }
        },
      );
    },
    async loadOptionCustomers({ action, searchQuery, callback }) {
      if (action === ASYNC_SEARCH) {
        this.customerModel.customerMobile = searchQuery;

        const result = await this.fetchCustomers(searchQuery);

        let optionCustomers = [];
        if (result.data.length) {
          optionCustomers = (result.data || []).map((element) => {
            return {
              id: element.id,
              label: element.phoneNo,
              customLabel: element.fullName,
            };
          });
        } else {
          optionCustomers = [
            {
              id: -1,
              label: searchQuery,
              customLabel: 'SĐT không có trong hệ thống',
              notFound: true,
            },
          ];
        }
        callback(null, optionCustomers);
      }
    },
    fetchCustomers(searchQuery) {
      const textInput = searchQuery ? searchQuery.trim() : null;

      if (!textInput) {
        return;
      }

      const params = {
        phoneNumber: textInput,
      };

      return ApiService.query(`customers/get-by-phone`, {
        params,
      }).then((response) => {
        return response.data;
      });
    },
    fetchCity() {
      ApiService.get('city/').then((data) => {
        const cities = data.data.data;
        this.listCity = cloneDeep(cities).reduce((result, element) => {
          if (element.value !== null) {
            result.push({
              id: element.id,
              label: element.name,
              custom: removeAccents(element.name),
            });
          }
          return result;
        }, []);
      });
    },
    getDistrict() {
      ApiService.get(`city/${this.customerModel.customerCity}/district`).then(
        (data) => {
          const districts = data.data.data;
          this.listDistrict = cloneDeep(districts).reduce((result, element) => {
            if (element.value !== null) {
              result.push({
                id: element.id,
                label: element.name,
                custom: removeAccents(element.name),
              });
            }
            return result;
          }, []);
        },
      );
    },
    getWard() {
      ApiService.get(`city/${this.customerModel.customerDistrict}/ward`).then(
        (data) => {
          const wards = data.data.data;
          this.listWard = cloneDeep(wards).reduce((result, element) => {
            if (element.value !== null) {
              result.push({
                id: element.id,
                label: element.name,
                custom: removeAccents(element.name),
              });
            }
            return result;
          }, []);
        },
      );
    },
    /**
     * Convert ISO/Date từ BE → 'YYYY-MM-DD' cho input[type=date].
     */
    toDateInput(value) {
      if (!value) return '';
      const s = String(value);
      // ISO '2026-05-07T...' hoặc '2026-05-07' → lấy 10 ký tự đầu nếu khớp YYYY-MM-DD
      if (/^\d{4}-\d{2}-\d{2}/.test(s)) return s.slice(0, 10);
      const d = new Date(value);
      if (Number.isNaN(d.getTime())) return '';
      const pad = (n) => String(n).padStart(2, '0');
      return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}`;
    },
    getCustomerInfoUpdatedById(customerId) {
      if (!customerId) {
        return;
      }
      ApiService.get(`customers/${customerId}`).then((response) => {
        const customerInfo = response.data.data;
        const customerName = this.customerModel.customerName
          ? this.customerModel.customerName.trim()
          : null;
        const customerAddress = this.customerModel.customerAddress
          ? this.customerModel.customerAddress.trim()
          : null;
        this.customerModel.customerName = customerName || customerInfo.fullName;
        this.customerModel.customerCity = customerInfo.city;
        this.customerModel.customerWard = customerInfo.ward;
        this.customerModel.customerDistrict = customerInfo.district;
        this.customerModel.customerAddress =
          customerAddress || customerInfo.address;
        this.customerModel.customerType = customerInfo.type;
        this.customerModel.customerAppellation = customerInfo.gender || null;
        this.customerModel.totalPoint = customerInfo.totalPoint || 0;
        // Pháp lý KH
        this.customerModel.customerEmail = customerInfo.email || '';
        this.customerModel.customerDob = this.toDateInput(
          customerInfo.dateOfBirth,
        );
        this.customerModel.customerCccdNo = customerInfo.cccdNo || '';
        this.customerModel.customerCccdDate = this.toDateInput(
          customerInfo.cccdDate,
        );
        this.customerModel.customerCccdPlace = customerInfo.cccdPlace || '';

        if (this.customerModel.customerCity !== null) {
          // this.getDistrict();
        }
        if (this.customerModel.customerDistrict !== null) {
          // this.getWard();
        }
        this.customerModel.customerLastName = customerInfo.lastName;
      });
    },
    getCustomerInfoById(customerId) {
      if (customerId) {
        ApiService.get(`customers/${customerId}`).then((response) => {
          const customerInfo = response.data.data;

          this.customerModel.customerName = customerInfo.fullName;
          this.customerModel.customerId = customerInfo.id;
          this.customerModel.customerAppellation = customerInfo.gender;
          this.customerModel.customerMobile = customerInfo.phoneNumber;
          // this.customerModel.customerCity = customerInfo.city;
          // this.customerModel.customerWard = customerInfo.ward;
          // this.customerModel.customerDistrict = customerInfo.district;
          this.customerModel.customerAddress = customerInfo.address;
          // Pháp lý KH
          this.customerModel.customerEmail = customerInfo.email || '';
          this.customerModel.customerDob = this.toDateInput(
            customerInfo.dateOfBirth,
          );
          this.customerModel.customerCccdNo = customerInfo.cccdNo || '';
          this.customerModel.customerCccdDate = this.toDateInput(
            customerInfo.cccdDate,
          );
          this.customerModel.customerCccdPlace = customerInfo.cccdPlace || '';
          // this.customerModel.customerType = customerInfo.type
          //   ? customerInfo.type
          //   : '';
          // if (this.customerModel.customerCity !== null) {
          //   this.getDistrict();
          // }
          // if (this.customerModel.customerDistrict !== null) {
          //   this.getWard();
          // }
          // this.customerModel.totalPoint = customerInfo.totalPoint;
          // const totalPoint = Number(customerInfo.totalPoint) || 0;
          // this.pointText = ` <b>(Tổng điểm:  ${totalPoint})</b>`;
          // this.customerModel.customerLastName = customerInfo.lastName;
        });
      }
    },
    getTransactionByCustomerId(customerId) {
      if (!customerId) {
        return;
      }
      ApiService.get(`customer/transaction/${customerId}`).then((response) => {
        const data = response.data.data;
        this.customerTransaction.orderCount = data.orders.length;
        this.customerTransaction.retailCount = data.retails.length;
        this.customerTransaction.wholesaleCount = data.wholesales.length;
        this.customerTransaction.refundCount = data.refunds.length;
        this.$emit('fetch-customer-transaction', data);
      });
    },
    viewCustomerTransaction: function () {
      const { href } = this.$router.resolve({
        name: 'update-customer',
        query: {
          id: this.customerModel.customerId,
          phoneNo: this.customerModel.customerMobile,
        },
      });
      window.open(href, '_blank');
    },
  },
};
</script>

<style scoped>
.type-appellation {
  display: flex;
  gap: 4px;
}

.border-bottom {
  border-bottom: 0.5px solid #e9e9e9;
}

.btn-group-customer-info .btn {
  padding: 0.05rem 0.05rem;
}

.vue-treeselect__input-container {
  padding-top: 0px;
}

.vue-treeselect__control {
  border-radius: 0.28rem;
  border: 1px solid #ced4da;
  height: 2.5rem;
}

.vue-treeselect--has-value .vue-treeselect__multi-value {
  margin-bottom: 2px;
}
.vue-treeselect__tip .vue-treeselect__no-results-tip {
  display: none;
}
</style>

<style lang="scss">
#popover-customer {
  .text-link:hover {
    cursor: pointer;
    color: blue;
  }
}
</style>
